import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { onPageNotVisible } from '../services/api';
import { plainText } from './drawer/refusal.mjs';
import { CloseBtn } from '../components/GhostBits';
// W13 (E8 page gate): the API refused a read with 403 PAGE_NOT_VISIBLE (this data belongs to a page the role cannot see). One shared notice for every screen,
// in plain EN / FR, so a report that swallows its read error never shows as a blank page.
export default function PageGateBanner() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  useEffect(() => onPageNotVisible(() => setOpen(true)), []);
  if (!open) return null;
  return <div className="toast show" role="alert" data-testid="page-gate-banner" style={{ pointerEvents: 'auto', bottom: 'auto', top: 60, zIndex: 200 }}>
    <span>{plainText('PAGE_NOT_VISIBLE', i18n.language)}</span>
    <CloseBtn onClick={() => setOpen(false)} />
  </div>;
}
